import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  max-width: 650px;
  margin: 10px auto 0;
  padding: 24px clamp(24px, calc((100vw - 320px) / 2), 150px);

  background: var(--white);
  border-radius: 4px;

  span {
    align-self: flex-start;
    color: var(--gray);
    font: var(--400-12);
  }

  button:first-of-type {
    margin-top: 16px;
  }
`
